import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "md:flex gap-2 md:gap-4 my-2 md:my-4 bg-[#1F1F1F] rounded-md p-2 md:p-4" }
const _hoisted_2 = { class: "grid grid-cols-[repeat(auto-fill,_minmax(8rem,_1fr))] gap-2 sm:gap-4 !z-10 w-full" }
const _hoisted_3 = { class: "relative min-w-[8rem] min-h-[8rem] aspect-square" }
const _hoisted_4 = { class: "bg-gray-700 rounded-md animate-pulse h-32 w-32 min-h-full min-w-full m-auto md:m-0" }
const _hoisted_5 = { class: "relative left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }
const _hoisted_6 = { class: "bg-white rounded-md py-1 sm:py-2 px-2 sm:px-4" }

import { Pagination } from 'ant-design-vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'HitomiGallerySkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(14), (_, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_a_spin, {
                    tip: "Loading...",
                    size: "large",
                    class: "animate-pulse"
                  })
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_unref(Pagination))
    ])
  ], 64))
}
}

})